export default __webpack_public_path__ + "static/media/Tissues-and-Wipes.45699243.png";